import * as React from "react";
import { useNavigate } from "@opendash/router";
import { AppLayout } from "./AppLayout";
import { useTexts } from "../hooks/useTexts";
import {
  TabContainer,
  TabButton,
  ContentContainer,
  WelcomeCard,
} from "./common/StyledComponents";

export const PrivathaushaltRoute = React.memo(function PrivathaushaltRoute() {
  const navigate = useNavigate();
  const { t } = useTexts();

  const tabs = [
    {
      title: t("privathaushalt.tab.1.title", "Wasserverbrauch & Spartipps"),
      path: "/wasserklaerer/privathaushalt/verbrauch",
      isActive: true,
    },
    {
      title: t("privathaushalt.tab.2.title", "Der Wasserpreis"),
      path: "/wasserklaerer/privathaushalt/preis",
      isActive: false,
    },
    {
      title: t("privathaushalt.tab.3.title", "Härtegrad des Wassers"),
      path: "/wasserklaerer/privathaushalt/haerte",
      isActive: false,
    },
  ];

  return (
    <AppLayout>
      <ContentContainer>
        <h1>{t("privathaushalt.main.title", "Wasser im privaten Haushalt")}</h1>

        <TabContainer>
          {tabs.map((tab, index) => (
            <TabButton
              key={index}
              isActive={tab.isActive}
              onClick={() => !tab.isActive && navigate(tab.path)}
            >
              {tab.title}
            </TabButton>
          ))}
        </TabContainer>

        <WelcomeCard>
          <h1>{t("privathaushalt.welcome.title", "Willkommen")}</h1>
          <p>
            {t(
              "privathaushalt.welcome.text",
              "Erfahren Sie mehr über Ihren Wasserverbrauch zu Hause, was Wasser kostet und welche Rolle die Wasserhärte spielt. Wählen Sie ein Thema aus den Tabs oben."
            )}
          </p>
        </WelcomeCard>
      </ContentContainer>
    </AppLayout>
  );
});
